import { useEffect } from 'react';

// Hook
function useHotkey(targetKey, callback) {
  // State for keeping track of whether key is pressed

  // Add event listeners
  useEffect(() => {
    // If pressed key is our target key then set to true
    function downHandler({ key }) {
      if (key === targetKey) {
        callback(key);
      }
    }

    window.addEventListener('keyup', downHandler); // keyup to not interfere with

    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keyup', downHandler);
    };
  }, [callback, targetKey]);
}

export default useHotkey;
